<template>
  <div>
    <!-- メインコンテンツ -->
    <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main new-modal">
        <h2>プラン利益分配率の設定</h2>

        <!-- 販売先選択 -->
        <div class="layer-selection">
          <label for="layer-select">販売先:</label>
          <select id="layer-select" v-model="selectedLayerId" @change="onLayerChange">
            <option v-for="layer in layerList" :key="layer.layerId" :value="layer.layerId">
              {{ layer.layerName }}
            </option>
          </select>
        </div>

        <!-- 工場ごとのタブ -->
        <div class="tab-menu">
          <button
            v-for="factory in uniqueFactories"
            :key="factory.factoryId"
            :class="{ active: activeFactoryId === factory.factoryId }"
            @click="selectFactory(factory.factoryId)"
          >
            {{ factory.factoryName }}
          </button>
        </div>

        <!-- 掛け率の表 -->
        <div v-if="activeFactory.length > 0 || isCustom">
          <h3>{{ getActiveFactoryName }} - {{ getLayerName(selectedLayerId) }}</h3>
          <table>
            <thead>
              <tr>
                <th>カテゴリ名</th>
                <th>工場出荷額</th>
                <th>配送料</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="category in categoryList" :key="category.profitCategoryId">
                <td>{{ category.profitCategoryName }}</td>
                <td>
                  <input
                    type="text"
                    :value="getProfitByType(activeFactory, category.profitCategoryId, 1)"
                    :disabled="!isCustom"
                    @input="updateProfit(category.profitCategoryId, 1, $event.target.value)"
                    @keydown="blockInvalidInput"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    :value="getProfitByType(activeFactory, category.profitCategoryId, 2)"
                    :disabled="!isCustom"
                    @input="updateProfit(category.profitCategoryId, 2, $event.target.value)"
                    @keydown="blockInvalidInput"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ボタンエリア -->
        <div class="button-area">
          <button @click="saveSettings">保存</button>
          <button @click="closeModal">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '../../../constants/App'

export default {
  data () {
    return {
      layerList: [], // サーバーから取得したレイヤのリスト
      factoryProfitList: [], // サーバーから取得した全データ
      categoryList: [], // サーバーから取得した全てのカテゴリ
      selectedLayerId: null, // 選択されたレイヤID
      editedData: {}, // 編集されたデータを保持する
      filteredFactories: [], // フィルタリングされた工場リスト
      activeFactoryId: null, // アクティブな工場ID
      modalShown: false,
      isCustom: false, // カスタムレイヤが選択されたかどうか
      backupFactoryProfitList: [] // 工場利益リストのバックアップ
    }
  },
  computed: {
    uniqueFactories () {
      const uniqueFactoriesMap = new Map()

      this.factoryProfitList.forEach(factoryProfit => {
        if (!uniqueFactoriesMap.has(factoryProfit.factoryId)) {
          uniqueFactoriesMap.set(factoryProfit.factoryId, {
            factoryId: factoryProfit.factoryId,
            factoryName: factoryProfit.factoryName
          })
        }
      })

      console.dir(this.factoryProfitList)

      return Array.from(uniqueFactoriesMap.values())
    },
    activeFactory () {
      return this.factoryProfitList.filter(factory => factory.factoryId === this.activeFactoryId && factory.factorySalesLayerId === this.selectedLayerId)
    },
    getActiveFactoryName () {
      if (this.isCustom) {
        return 'カスタム'
      }
      const factory = this.activeFactory[0]
      return factory ? factory.factoryName : ''
    }
  },
  methods: {
    showModal () {
      this.fetchData()
      this.modalShown = true
      // データのバックアップを作成
      this.operateEventListener() // イベントリスナーの設定
    },
    closeModal () {
      this.modalShown = false
      // バックアップからデータを元に戻す
      this.factoryProfitList = JSON.parse(JSON.stringify(this.backupFactoryProfitList))
      this.operateEventListener() // イベントリスナーの解除
    },
    filterFactoriesByLayer () {
      this.filteredFactories = this.factoryProfitList.filter(factoryProfit =>
        factoryProfit.factorySalesLayerId === this.selectedLayerId
      )
      if (this.filteredFactories.length > 0) {
        this.activeFactoryId = this.filteredFactories[0].factoryId
      } else {
        if (this.isCustom) {
          this.activeFactory = this.factoryProfitList[0].factoryId
        } else {
          this.activeFactoryId = null
        }
      }
    },
    selectFactory (factoryId) {
      this.activeFactoryId = factoryId
    },
    onLayerChange () {
      this.isCustom = (this.selectedLayerId === 99) // カスタムレイヤ選択時
      this.filterFactoriesByLayer()
    },
    getUniqueLayers (factoryProfitList) {
      const layers = []
      factoryProfitList.forEach(factoryProfit => {
        if (!layers.some(l => l.layerId === factoryProfit.factorySalesLayerId)) {
          layers.push({ layerId: factoryProfit.factorySalesLayerId, layerName: factoryProfit.factorySalesLayerName })
        }
      })
      return layers
    },
    getProfitByType (factoryProfitModel, categoryId, type) {
      if (!factoryProfitModel || factoryProfitModel.length === 0) {
        return 0
      }

      const profit = factoryProfitModel.find(
        profit => profit.profitCategoryId === categoryId && profit.factoryPriceType === type
      )
      return profit ? profit.factoryProfitRate : 0
    },
    updateProfit (categoryId, type, value) {
      const profit = this.factoryProfitList.find(
        profit => profit.profitCategoryId === categoryId && profit.factoryPriceType === type && profit.factoryId === this.activeFactoryId && profit.factorySalesLayerId === this.selectedLayerId
      )

      if (profit) {
        profit.factoryProfitRate = parseFloat(value) || 0
      } else {
        this.factoryProfitList.push({
          factoryId: this.activeFactoryId,
          factoryPriceType: type,
          profitCategoryId: categoryId,
          factoryProfitRate: parseFloat(value) || 0,
          factorySalesLayerId: this.selectedLayerId,
          factorySalesLayerName: this.getLayerName(this.selectedLayerId)
        })
      }
    },
    blockInvalidInput (event) {
      // 数値以外の入力をブロック
      const invalidChars = ['-', '+', 'e', 'E']
      if (invalidChars.includes(event.key)) {
        event.preventDefault()
      }
    },
    switchToCustomLayer () {
      this.isCustom = true
      this.selectedLayerId = 99
    },
    getLayerName (layerId) {
      const layer = this.layerList.find(l => l.layerId === layerId)
      return layer ? layer.layerName : ''
    },
    saveSettings () {
      const payload = this.preparePayload()
      axios.post(API_URL.FACTORY + '/update-factory', payload, {
        params: {layerId: this.selectedLayerId}
      })
        .then(response => {
          this.$emit('saved')
          this.modalShown = false
          this.operateEventListener()
        })
        .catch(error => {
          console.error('APIエラー:', error)
        })
    },
    preparePayload () {
      const payload = []
      // 現在のレイヤIDに属するすべての工場データを取得
      const currentLayerData = this.factoryProfitList.filter(profit => profit.factorySalesLayerId === this.selectedLayerId)
      currentLayerData.forEach(item => {
        payload.push({
          factoryId: item.factoryId,
          factoryPriceType: item.factoryPriceType,
          planProfitCategoryId: item.profitCategoryId,
          planProfitCategoryName: item.profitCategoryName,
          planProfitRate: item.factoryProfitRate
        })
      })
      return payload
    },
    fetchData () {
      axios.get(API_URL.FACTORY + '/read-profit')
        .then(response => {
          this.factoryProfitList = response.data.data.factoryProfitList
          this.layerList = this.getUniqueLayers(this.factoryProfitList)

          // サーバーからの初期値に「カスタム」レイヤーが含まれているか確認し、ない場合のみ追加
          if (!this.layerList.some(layer => layer.layerId === 99)) {
            this.layerList.push({ layerId: 99, layerName: 'カスタム' })
          }
          // 販売先、タブの選択の初期値
          this.selectedLayerId = response.data.data.layerId
          this.isCustom = (this.selectedLayerId === 99) // カスタムレイヤ選択時
          this.filterFactoriesByLayer() // 初期データロード時にフィルタリングを実行

          // データバックアップ
          this.backupFactoryProfitList = JSON.parse(JSON.stringify(this.factoryProfitList))
        })
        .catch(error => {
          console.error(error)
        })

      axios.get(API_URL.FACTORY + '/read-category')
        .then(response => {
          this.categoryList = response.data.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    operateEventListener () {
      if (this.modalShown) {
        this.$emit('onShowModal')
      } else {
        this.$emit('onCloseModal')
      }
    }
  },
  created () {
  }
}
</script>

<style scoped>
.modal .modal-main {
  width: 90%;
  height: 80%;
  max-width: initial;
  max-height: initial;
}
/* タブメニューのスタイル */
.tab-menu {
  display: flex;
  margin-bottom: 20px;
}

.tab-menu button {
  flex: 1;
  padding: 10px;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  cursor: pointer;
}

.tab-menu button.active {
  background-color: #007bff; /* 選択されたタブの背景色を青に設定 */
  color: white; /* 選択されたタブの文字色を白に設定 */
}

.layer-selection {
  margin-bottom: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

thead {
  background-color: #f9f9f9;
}

tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.button-area {
  margin-top: 20px;
  text-align: center;
}
/* 編集不可のinputからオレンジ色のアウトラインを削除 */
input:disabled {
  outline: none;
  border: none; /* 境界線も削除したい場合 */
  background-color: #f9f9f9; /* 任意の背景色に変更 */
  cursor: not-allowed; /* 無効状態を示すカーソル */
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/ProfitSettingModal.vue